import { render, staticRenderFns } from "./NakesAdd.vue?vue&type=template&id=47de0304&scoped=true"
import script from "./NakesAdd.vue?vue&type=script&lang=js"
export * from "./NakesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de0304",
  null
  
)

export default component.exports